function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as modalActions } from '../../reducers/modal.reducer';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import FormsAdd from './FormsAdd.modal';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
var Forms = function Forms() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app;
  var dispatch = useDispatch();
  var forms = useSelector(function (s) {
    return s.ppc.forms;
  });
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.forms,
      payload: {}
    });
  }, []);
  var columns = {};
  var data = [];
  var form = Object.values(forms).find(function (x) {
    return x._id === selected;
  });
  columns = {
    id: {
      title: '_id',
      visible: false
    },
    slot: {
      title: 'slot',
      visible: false
    },
    groupTitle: {
      title: 'Form Group Title',
      onClick: function onClick(_ref) {
        var row = _ref.row;
        return navigate("/".concat(app, "/forms/").concat(row._id));
      }
    }
  };
  data = Object.values(forms).filter(function (x) {
    return !x.archived && x.clientApp === app;
  }).map(function (x) {
    return {
      _id: x._id,
      groupTitle: x.groupTitle,
      slot: x.slot
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: !selected ? 'Form Groups' : form === null || form === void 0 ? void 0 : form.groupTitle,
    button: !selected ? {
      label: 'Add',
      type: 'add',
      onClick: function onClick() {
        dispatch({
          type: modalActions.add,
          payload: {
            component: /*#__PURE__*/React.createElement(FormsAdd, {
              app: app
            })
          }
        });
      },
      permission: "edit-".concat(app, "-forms")
    } : {
      label: 'Back',
      type: 'cancel',
      onClick: function onClick() {
        return setSelected(null);
      }
    }
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    sort: {
      by: 'slot'
    }
  }))));
};
export default Forms;